import type { PostMessageFunction } from './types/PostMessageFunction';
import type { MessageInterface } from './types/MessageInterface';
import { Logger } from '@thesavingsgroup/logger/Logger';

type PostMessageDependencies = {
  global?: Window;
  logger?: Logger;
  targetOrigin?: string;
};

export const postMessage =
  ({
    global = window?.parent ? window.parent : window,
    logger = new Logger(),
    targetOrigin = '*',
  }: PostMessageDependencies = {}): PostMessageFunction =>
  (message: MessageInterface): void => {
    logger.info('[COMPONENTS] Posting message', { message, targetOrigin });
    global.postMessage(message, targetOrigin);
  };
